import { AvailableLanguages } from '@repo/toolkit/language-types'
import { electronicFormat, isValid } from 'iban-ts'
import { z } from 'zod'

import { t } from '../../../locale/utils'

export const ibanValidation = (language: AvailableLanguages) =>
  z
    .string({
      required_error: t('errors.iban.required', { lng: language })
    })
    .refine((iban) => isValid(iban), {
      message: t('errors.iban.invalid', { lng: language })
    })
    .transform((iban) => electronicFormat(iban)) // Format to electronic IBAN (remove spaces, etc.)
